const actionTypes = {
    SHOW_MEGA_WINS: 'megaWins/SHOW_MEGA_WINS',
    CLOSE_MEGA_WINS: 'megaWins/CLOSE_MEGA_WINS',
};

let lastId = 0;

const getNextId = () => lastId++;

const roundWinAmount = winAmount => {
    if (winAmount < 1000) {
        return winAmount.toFixed(2)
      } else if (winAmount < 1000000) {
        return `${(winAmount / 1000).toFixed(2)}K`
      } else if (winAmount < 1000000000) {
        return `${(winAmount / 1000000).toFixed(2)}M`
      } else {
        return `${(winAmount / 1000000000).toFixed(2)}B`
      }
}

const showMegaWins = winAmount => async (dispatch) => {
    dispatch({ type: actionTypes.SHOW_MEGA_WINS, payload: { winId: getNextId(), winAmount: roundWinAmount(Number(winAmount)) } });
};

const closeMegaWins = id => async dispatch => {
    dispatch({ type: actionTypes.CLOSE_MEGA_WINS, payload: id });
};

export {
    actionTypes,
    showMegaWins,
    closeMegaWins,
};